import { useFormContext } from "react-hook-form";
import {Stack } from "@mui/material";
import { AlarmScheduleFormType, blackoutDayOptions } from "./AlarmScheduleEditorUtils";
import { FormSquareChip } from "../../../components/forms/form-square-chip/FormSquareChip";

export type BlackoutDayOptionsProps = {
    index: number
};

export default function BlackoutDayOptions({
    index,
}: BlackoutDayOptionsProps) {

    const {
        //getValues,
        watch,
        //trigger,
        //control,
        //reset,
        //setValue,
        //resetField
    } = useFormContext<AlarmScheduleFormType>();    
    
    const [
        setBlackoutDays
     ] = watch([
        'setBlackoutDays'
    ]);

    return (
        <Stack direction='row' 
            sx={{
                justifyContent: 'flex-start'
            }} 
        >
            {blackoutDayOptions.map((o, ndx) => (
                
                <FormSquareChip 
                    key={ndx}
                    name={`blackoutSchedules.${index}.${o.Value}`}
                    label={`${o.Key}`}
                    size="medium"
                    checkedColorOverride="black"
                    disabled={!setBlackoutDays}
                />
            ))}
        </Stack>
    );
}

